export default {
  'status_checks.archive.error':
    'There was an issue archiving {{healthCheckName}} Health Check. Please try again later.',
  'status_checks.continuous.label': 'Continuous Health Check',
  'status_checks.delete.error':
    'There was an error while removing the Health Check. Please try again later.',
  'status_checks.delete.success': 'Health Check removed successfully',
  'status_checks.delete.label': 'Delete Health Check',
  'status_checks.edit.label': 'Edit Health Check',
  'status_checks.new.label': 'New Health Check',
  'status_checks.run.continuous.label':
    'Allow this Health Check to run continuously during your scenario (polling every 10 seconds)',
  'status_checks.retrieval.error':
    'There was an issue while retrieving the Health Checks',
  'status_checks.save.error':
    'There was an issue saving this Health Check. Please try again later.',
  'status_checks.save.success': 'Health Check saved successfully.',
  'status_checks.label.singular': 'Health Check',
  'status_checks.label.plural': 'Health Checks',
  'status_checks.page_name': 'Health Checks',
  'status_checks.create': 'Create Health Check',
  'status_checks.authentication': 'Authentication',
  'status_checks.authentication_list': 'Authentication List',
  'status_checks.header.description':
    'Health Checks will be shared across your team for use in Scenarios as well as Services, if you have Reliability Management. Gremlin will work with your existing observability and monitoring tools to automatically halt tests that are causing your Service or Scenario to fail.  If you don’t have your monitors set up yet, we recommend setting up monitors that look at: latency, traffic, error rate, and resource saturation. For Reliability Management, each of your services will need a Health Check to evaluate whether your Reliability Tests have passed or failed.',
  'status_checks.list.retrieve.error':
    'There was an issue while retrieving Health Checks',
  'status_checks.list.headers.name': 'Name',
  'status_checks.list.headers.actions': 'Actions',
  'status_checks.list.empty_text': 'No Health Checks',
  'status_checks.list.delete.error':
    'There was a problem while removing the Health Check. Please try again.',
  'status_checks.list.delete_modal.text':
    'Are you sure you want to delete this Health Check?',
  'status_checks.list.delete_modal.title': 'Delete Health Check?',
  'status_checks.list.delete.success':
    'Successfully deleted Health Check {{name}}',
  'status_checks.authentication_list.description':
    'Observability Tools are defined during Health Check creation so your team can reuse the tool’s definitions and authentications.',
  'status_checks.authentication_list.headers.name': 'Observability Tool',
  'status_checks.authentication_list.headers.actions': 'Actions',
  'status_checks.authentication_list.edit': 'Edit',
  'status_checks.authentication_list.delete.success':
    'Successfully deleted Authentication',
  'status_checks.authentication_list.loading.error':
    'There was an issue while retrieving Authentications',
  'status_checks.authentication_list.empty_text': 'No Authentications'
}
